"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _a;

var is_1 = require("../../utilities/is");
/**
 * Namespaces
 */


exports.APPS = {
  beacon: 'beacon',
  hsApp: 'hs-app'
};
exports.propProviderAppNamespace = '__BLUE_SECRET_PROP_PROVIDER_GLOBAL_APP__';
exports.propProviderAppNamespaceValue = 'blue'; // HTML friendly key for PropProviderAppProp
// 🖋 🍍 🍎 🖋
// https://www.youtube.com/watch?v=0E00Zuayv9Q

exports.propProviderDataAttr = 'data-blue-ppap';
/**
 * Default Config
 */

exports.contextConfig = (_a = {}, // Default app "environment" is Blue - "Da ba dee, da ba die"
_a[exports.propProviderAppNamespace] = exports.propProviderAppNamespaceValue, _a);
/**
 * Sets the internal global app namespace for Blue components.
 * @param {Object} config The initial PropProvider config.
 * @param {string} namespace The namespace for the App.
 * @returns {Object} The modified PropProvider config.
 */

function setGlobalApp(config, namespace) {
  var _a;

  var baseConfig = !is_1.isPlainObject(config) ? exports.contextConfig : config;
  var appNamespace = is_1.isString(namespace) ? namespace : exports.propProviderAppNamespaceValue;
  return __assign({}, baseConfig, (_a = {}, _a[exports.propProviderAppNamespace] = appNamespace, _a));
}

exports.setGlobalApp = setGlobalApp;
/**
 * Retrieves the internal global config for Blue components.
 * @param {Object} config The initial PropProvider config.
 * @returns {Object} The PropProvider global config
 */

function getGlobal(config) {
  var baseConfig = is_1.isPlainObject(config) ? config : exports.contextConfig;

  if (!baseConfig.hasOwnProperty(exports.propProviderAppNamespace)) {
    baseConfig[exports.propProviderAppNamespace] = exports.propProviderAppNamespaceValue;
  }

  return baseConfig;
}

exports.getGlobal = getGlobal;
/**
 * Retrieves the internal global app namespace for Blue components.
 * @param {Object} config The initial PropProvider config.
 * @returns {string} The namespace for the App.
 */

function getGlobalApp(config) {
  var globalConfig = getGlobal(config);
  return globalConfig[exports.propProviderAppNamespace];
}

exports.getGlobalApp = getGlobalApp;

function getGlobalAppFromProps(props) {
  return props[exports.propProviderDataAttr];
}

exports.getGlobalAppFromProps = getGlobalAppFromProps;

function isBeacon(props) {
  return getGlobalAppFromProps(props) === exports.APPS.beacon;
}

exports.isBeacon = isBeacon;

function isHSApp(props) {
  return !!(getGlobalAppFromProps(props) === exports.APPS.hsApp || // @ts-ignore
  props.theme && getGlobalAppFromProps(props.theme) === exports.APPS.hsApp);
}

exports.isHSApp = isHSApp;
/**
 * Merge contextProps with parent contextProps.
 * @param   {Object} props The initial PropProvider configs.
 * @param   {Object} nextProps The next PropProvider configs.
 * @returns {Object} The merged props.
 */

function shallowMergeProps(props, nextProps) {
  if (props === void 0) {
    props = {};
  }

  if (nextProps === void 0) {
    nextProps = {};
  } // Safety check


  var safeProps = is_1.isPlainObject(props) ? props : {};
  var safeNextProps = is_1.isPlainObject(nextProps) ? nextProps : {};

  var mergedProps = __assign({}, safeProps);

  Object.keys(safeNextProps).forEach(function (key) {
    var prop = mergedProps[key];
    var nextProp = safeNextProps[key];

    if (prop) {
      if (is_1.isPlainObject(nextProp)) {
        mergedProps[key] = __assign({}, prop, nextProp);
      } else {
        mergedProps[key] = nextProp;
      }
    } else {
      mergedProps[key] = nextProp;
    }
  });
  return mergedProps;
}

exports.shallowMergeProps = shallowMergeProps;
/**
 * Attempts to retrieve the specified config props.
 *
 * @param   {Object} config The PropProvider configs.
 * @param   {Array<string> | Function | Object | string} getter The namespace of the config.
 * @returns {Object} The retrieved config props.
 */

function getConfigProps(config, getter) {
  if (getter === void 0) {
    getter = '';
  }

  if (!config) return exports.contextConfig;
  var props = {};

  if (typeof getter === 'string') {
    props = config.hasOwnProperty(getter) ? config[getter] : {};
  }

  if (typeof getter === 'function') {
    props = getter(config);
  }

  if (Array.isArray(getter)) {
    props = getConfigPropsFromArray(config, getter);
  }

  if (is_1.isObject(getter)) {
    var propKeys = Object.keys(getter).filter(function (key) {
      return getter[key];
    });
    props = getConfigPropsFromArray(config, propKeys);
  }

  return props;
}

exports.getConfigProps = getConfigProps;
/**
 * Retrieves props from a config (Object), given a collection of keys.
 *
 * @param   {Object} config The initial config.
 * @param   {Array<string>} array A collection of keys to get.
 * @returns {Object} The remapped config.
 */

function getConfigPropsFromArray(config, array) {
  if (config === void 0) {
    config = {};
  }

  if (!is_1.isObject(config)) return {};
  if (!is_1.isArray(array)) return config;
  return array.filter(function (value) {
    return is_1.isString(value);
  }).reduce(function (remappedProps, key) {
    remappedProps[key] = config[key];
    return remappedProps;
  }, {});
}

exports.getConfigPropsFromArray = getConfigPropsFromArray;